import { createSelector } from '@reduxjs/toolkit';
import { selectDevicesFields } from 'entities/device/lib';
import { isSocketDevice } from 'entities/billing.buy-socket-03-thermostat/lib/is-socket';
export const getSockets03Device = createSelector(selectDevicesFields([
    'device_type',
    'hardware_type',
    'serial',
    'name',
    'individual_device_name',
]), (devices) => devices.filter(isSocketDevice));
